// extracted by css-extract-rspack-plugin
var _1 = "Etzx49RXsYEUkraV";
var _2 = "DwxkEn75GFwsXtQQ";
var _3 = "RZznQnJ0juIKdZ41";
export { _1 as "center", _2 as "left", _3 as "right" }
